document.addEventListener("DOMContentLoaded", function(event) {
  //let productFlavorsSelected = document.querySelector('.rtnu-pdp__flavors-list .selected-variant');
  
  //if (productFlavorsSelected) {
    //productFlavorsSelected.scrollIntoView({ block: 'end', inline: 'center' });
  //}

  function getElementPositionInScrollableParent(element, scrollableParent) {
      // Get the element's position relative to the viewport
      const elementRect = element.getBoundingClientRect();

      // Get the scrollable parent's position relative to the viewport
      const parentRect = scrollableParent.getBoundingClientRect();

      // Calculate the element's position relative to the scrollable parent's content area
      const relativeTop = elementRect.top - parentRect.top + scrollableParent.scrollTop;
      const relativeLeft = elementRect.left - parentRect.left + scrollableParent.scrollLeft;

      return {
          top: relativeTop,
          left: relativeLeft
      };
  }

  // Example usage:
  const scrollableDiv = document.querySelector('.rtnu-pdp__flavors-list');
  const targetElement = document.querySelector('.rtnu-pdp__flavors-list .selected-variant');

  if (scrollableDiv && targetElement) {
    let position = getElementPositionInScrollableParent(targetElement, scrollableDiv);
    scrollLeft = position.left - (window.innerWidth / 2.5);
    scrollableDiv.scrollBy({
      left: scrollLeft ,
      behavior: 'smooth' // Optional: for smooth scrolling animation
    });
  }
});